import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Input, DatePicker, TimePicker, Select, Row, Col, message, AutoComplete, Spin } from 'antd';
import 'antd/dist/antd.css';
import './styles.css';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import api from '../../services/api';
import MaskedInput from 'react-input-mask';
import { instituicaoEncaminhamentoService } from '../../services/Instituicao-Encaminhamento-Service/instituicao-encaminhamento-service';
import InputSelectMeioComunicacao from '../InputSelectMeioComunicacao';
import InputSelectInstituicaoEncaminhamento from '../InputSelectInstituicaoEncaminhamento';
import { maskTelefone, onKeyDownBloquearDigitosPorLength, validarTelefoneCelular } from '../../utils/telefone';
import MaskedTextInput from 'react-text-mask'
import InputSelectMunicipio from '../InputSelectMunicipio';

interface ModalAgendamentoProps {
    modalStatus?: any,
    setAgendamentoModal?: any,
    permissao?: any,
}


const ModalAgendamento: React.FC<ModalAgendamentoProps> = (prop) => {

    interface Agendamento {
        AgendamentoID?: number,
        Nome: string,
        PaisOrigem: string,
        DataHoraInicio: Date,
        Duracao: number,
        Motivo: string,
        Telefone: string,
        DadosCadastraisID?: number,
        UsuarioID: number
    }

    interface DadosCadastrais {
        DadosCadastraisID?: number,
        Nome: string,
        PaisOrigem: string,
        DataNascimento: Date,
    }

    const [loading, setLoading] = useState(false);
    let visible = prop.modalStatus[0].visibleAgendamento
    const { TextArea } = Input;
    const { Option } = Select;
    const [form] = Form.useForm();
    const [agendamento, setAgendamento] = useState<Agendamento>();
    const [optionsInput, setOptionsInput] = useState<any[]>();
    const [instituicaoEncaminhamentoInput, setInstituicaoEncaminhamentoInput] = useState<any[]>();
    let time: any;
    let option: any;
    var options: any[] = [];
    
    useEffect(() => {
        form.resetFields();
        instituicaoEncaminhamentoService.getAll().then(res => {
            if (res.status == 200)
                setInstituicaoEncaminhamentoInput(res.data)
        })

        // if (prop.modalStatus[0].dataInfo != null) {
        //     form.setFieldsValue({ dataAgendamento: moment(new Date(prop.modalStatus[0].dataInfo), 'DD/MM/YYYY HH:mm').utc(false).add(8, 'hour') })
        // }
        // else {
        //     form.setFieldsValue({ dataAgendamento: moment(new Date(), 'DD/MM/YYYY HH:mm').utc(true) })
        // }
    }, [prop.modalStatus[0].visibleAgendamento])

    const handleCancel = () => {
        prop.setAgendamentoModal(false);
    };

    const onSelect = async (value: any, option: any) => {
        setLoading(true);
        await api.get(`DadosImigracao/getbyDadosCadastraisID?id=${option.value}`).then((res) => {
            if (res.data)
                form.setFieldsValue({ telefone: res.data.telefone })
            else
                form.setFieldsValue({ telefone: '' })
        })
            .finally(() => {
                setLoading(false)
            })
        form.setFieldsValue({ pais: option.pais })
        form.setFieldsValue({ telefone: option.telefone == null ? "" : maskTelefone(option.telefone.replace(/\W/g, '')) })
        form.setFieldsValue({ dadosCadastraisID: option.value })
        form.setFieldsValue({ nome: option.label })
    };

    const configOptions = (dados: any[]) => {
        dados.map((a: any) => {
            option = {
                value: a.dadosCadastraisID,
                label: a.nome + ' - ' + a.pais,
                pais: a.pais,
                telefone: a.telefone
            }
            options.push(option)
        })
        setOptionsInput(options)
    }

    const buscarMigrante = (e: any) => {
        clearTimeout(time);
        time = setTimeout(() => {
            api.get(`DadosCadastrais/getbynome?nome=${e}`).then((response) => {
                configOptions(response.data)
            })

        }, 1000);
    }

    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [date, time] = dateTimeString.split(' ');
        // Dividimos a data em dia, mês e ano:
        const [DD, MM, YYYY] = date.split('/');
        // Dividimos o tempo em hora e minutos:
        const [HH, mm] = time.split(':');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD}T${HH}:${mm}Z`;
    }

    const onFinish = async (values: any) => {
        let result = moment(values.dataAgendamento, 'DD/MM/YYYY HH:mm', true).isValid();
        let dataFormatada = toISOFormat(values.dataAgendamento);
        let dataInicio = new Date(dataFormatada);
        var usuarioLogado = JSON.parse(sessionStorage.getItem('usuarioLogado') || '{}')

        if (result) {
            setLoading(true);
            await api.post("Agendamento", {
                AgendamentoID: undefined,
                Nome: values.nome,
                DataHoraInicio: dataInicio,
                PaisOrigem: values.pais,
                Motivo: values.motivo,
                Telefone: values.telefone,
                InstituicaoEncaminhamentoID: values.instituicaoEncaminhamentoID,
                MeioComunicacaoID: values.meioComunicacaoID,
                MunicipioID: values.municipioID,
                DadosCadastraisID: values.dadosCadastraisID,
                UsuarioAgendamentoID: usuarioLogado.usuarioID,
                UsuarioAgendamentoNome: usuarioLogado.nomeUsuario,
            })
                .then((response: any) => {

                    if (response.data.valido) {
                        message.success('Agendamento salvo com sucesso')
                        prop.setAgendamentoModal(false)
                    }
                    else {
                        message.error(response.data.error)
                    }
                    prop.setAgendamentoModal(false);
                })
                .catch((err) => {
                    message.error('Falha na requisição')

                })
                .finally(() => {
                    setLoading(false);
                })


        }
        else {
            message.error('Data Inválida')
        }
    }

    const onFinishFailed = (errorInfo: any) => {

    };

    function disabledDate(current: any) {
        return current < moment().endOf('day').subtract(1, 'day');
    }


    const validarData = (_: any, value: { number: number }) => {
        let dataValida = moment(form.getFieldValue("dataAgendamento"), 'DD/MM/YYYY HH:mm', true).isValid();
        let data = moment(form.getFieldValue("dataAgendamento"), 'DD/MM/YYYY HH:mm', true).toDate();

        if (dataValida == false) {
            return Promise.reject(new Error('Data ou Hora inválida!'));
        }

        if (data.getDate() == new Date().getDate() && data.getFullYear() == new Date().getFullYear() && data.getMonth() == new Date().getMonth()) {
            if (moment(form.getFieldValue("dataAgendamento"), 'DD/MM/YYYY HH:mm', true).isBefore(new Date))
                return Promise.reject(new Error('A hora não pode ser menor que a hora atual!'));
        } else {
            if (moment(form.getFieldValue("dataAgendamento"), 'DD/MM/YYYY HH:mm', true).isBefore(new Date))
                return Promise.reject(new Error('A data não pode ser menor que a data atual!'));
        }

        return Promise.resolve();
    };

    function disabledDateTime() {
        return {
            disabledHours: () => {
                let disabled = Array.from({ length: (24 - 0) }, (v, k) => k + 0).slice(0, 8)
                let fim = Array.from({ length: (24 - 0) }, (v, k) => k + 0).slice(18, 24)
                disabled = disabled.concat(fim)
                return disabled;
            },
        };
    }
    return (
        <Modal
            visible={visible}
            title="Agendamento"
            onCancel={handleCancel}
            footer={null}
            width="700px"

        >
            <Spin spinning={loading}>
                <Form
                    name="agendamento"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    form={form}
                >
                    <Form.Item
                        label="DadosCadastraisID"
                        name="dadosCadastraisID"
                        hidden={true}
                    >
                        <Input type="number" hidden={true} />

                    </Form.Item>

                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item
                                label="Nome"
                                name="nome"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor insira um nome!',
                                    }
                                ]}
                            >
                                <AutoComplete
                                    dropdownMatchSelectWidth={252}
                                    options={optionsInput}
                                    onSelect={onSelect}

                                    onSearch={buscarMigrante}
                                >
                                    <Input.Search size="middle" placeholder="Informe o Nome" enterButton />
                                </AutoComplete>

                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label="País de Origem"
                                name="pais"
                            >
                                <Input placeholder="Informe o País do Migrante" disabled />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label="Telefone"
                                name="telefone"
                                rules={[{validator: (_, value) => validarTelefoneCelular(value), validateTrigger: "onSubmit"}]}
                            >
                                  <MaskedTextInput className="ant-input" onKeyDown={(e: any) => { onKeyDownBloquearDigitosPorLength(e, 11) }}
                                    mask={(value: any) => {
                                        if (value && value.replace(/\D/g, '').length >= 11) {
                                            return [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                                        } else {
                                            return [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>

                    </Row>

                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item
                                label="Data e Hora"
                                name="dataAgendamento"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor insira uma data e hora!',
                                    },

                                    {
                                        validator: validarData
                                    },
                                ]}
                            >
                                <MaskedInput className="ant-input" mask="99/99/9999 99:99" />
                                {/* <DatePicker disabledDate={disabledDate} disabledTime={disabledDateTime} placeholder="Selecione a Data" showTime style={{ width: '100%' }} format="DD/MM/YYYY HH:mm" /> */}
                            </Form.Item>
                        </Col>

                        {/* <Col className="gutter-row" span={8}>
                            <Form.Item
                                label="Duração"
                                name="duracao"
                                initialValue={15}
                            >
                                <Select placeholder="Minutos">
                                    <Option value={15}>15min</Option>
                                    <Option value={30}>30min</Option>
                                    <Option value={45}>45min</Option>
                                    <Option value={60}>60min</Option>
                                </Select>
                            </Form.Item>
                        </Col> */}
                    </Row>

                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <InputSelectInstituicaoEncaminhamento />
                        </Col>
                    </Row>

                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <InputSelectMunicipio />
                        </Col>
                    </Row>                    

                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <InputSelectMeioComunicacao />
                        </Col>
                    </Row>

                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item
                                label="Motivo"
                                name="motivo"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor insira um motivo!',
                                    }
                                ]}
                            >
                                <TextArea maxLength={450} showCount rows={4}></TextArea>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item>
                        {prop.permissao[0]?.permissaoAcesso?.cadastrar === true ?
                            <Button className="button-agendar" type="primary" htmlType="submit">
                                Agendar
                            </Button>
                            : null}
                    </Form.Item>
                </Form>
            </Spin>
        </Modal >
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}

export default connect(mapStateToProps, mapDispatcToProps)(ModalAgendamento);